import { Autocomplete, Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { CircleLoader } from "react-spinners";
import { obtenerProductosParaElHome } from "../../services/productServices";
import { RiDeleteBinLine } from 'react-icons/ri';
import { getProductosHome, modificarProductosHome } from "../../services/PanelService";

function HomeProductsTab() {



    const [stockedProducts, setStockedProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [codigo, setCodigo] = useState("");
    const [selectedProducts, setSelectedProducts] = useState([]);

    const getProductos = async () => {
        setLoading(true);
        const productos = await obtenerProductosParaElHome();
        const final = productos.map(prod => {
            prod.codigoFinal = `${prod.UserId}.${prod.codigoProducto}`
            return prod;
        })

        const selectedProducts = await getProductosHome();

        const selProdFinal = []

        selectedProducts.forEach(selProd => {
            const foundProd = final.find(fp => fp.codigoFinal === selProd);
            if (foundProd) selProdFinal.push(foundProd)
        })

        setSelectedProducts(selProdFinal);

        setStockedProducts(final);
        setLoading(false);
    }

    const guardarCambios = async () => modificarProductosHome(selectedProducts.map(prod => prod.codigoFinal))

    useEffect(() => {
        getProductos();
    }, [])

    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: 'center', alignItems: "center" }}>
            <div style={{ width: "100%" }}>
                <CircleLoader loading={loading} cssOverride={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
                <Autocomplete
                    options={stockedProducts}
                    isOptionEqualToValue={(option, value) => option.codigoFinal === value.codigoFinal}
                    inputValue={codigo}
                    onInputChange={(_, newInputValue) => {
                        setCodigo(newInputValue);
                    }}
                    onChange={(_, value, reason) => {
                        if (reason === "selectOption") {
                            setSelectedProducts(prev => [...prev, value]);
                        }
                        setCodigo("");
                    }}
                    getOptionLabel={option => option.codigoFinal}
                    renderOption={(props, option) => {
                        return <li {...props} key={option._id}>{option.codigoFinal}</li>
                    }}
                    renderInput={params => <TextField {...params} label='Elija un producto' variant='outlined' />}
                />
                <div style={{ display: 'flex', flexDirection: "row", flexWrap: "wrap" }}>
                    {selectedProducts.map((prod) =>
                        <div key={prod._id} style={{ position: 'relative', display: "flex", flexDirection: "column", borderColor: "black", borderStyle: "solid", borderWidth: 1, borderRadius: 5, justifyContent: "center", alignItems: "center", margin: 10, padding: 15, width: "16%", overflow: "hidden" }} >
                            <img style={{ height: 200, width: '80%' }} src={`${process.env.REACT_APP_API_URL}images/${prod.codigoFinal}.jpeg`} />
                            <p style={{ textAlign: 'center', fontWeight: 'bold' }}>{prod.descripcion}</p>
                            <p style={{ textAlign: 'center', fontWeight: 'bold' }}>{prod.marca}</p>
                            <p style={{ textAlign: 'center', fontWeight: 'bold' }}>{prod.talle}</p>
                            <p style={{ textAlign: 'center', fontWeight: 'bold' }}>${prod.precio}</p>
                            <RiDeleteBinLine style={{ position: "absolute", bottom: 15, right: 15 }} color="darkred" size={35} onClick={() => setSelectedProducts(prev => prev.filter(selectedProd => prod.codigoFinal !== selectedProd.codigoFinal))} />
                        </div>)}
                </div>
            </div>
            <Button onClick={guardarCambios} style={{ margin: 20 }} color='primary' variant='contained'>Guardar Cambios</Button>
        </div>
    )
}

export default HomeProductsTab